// extracted by mini-css-extract-plugin
module.exports = {"table":"DefaultSimpleTable_table__318Z8","sizeSmall":"DefaultSimpleTable_sizeSmall__3pPb_","emptyState":"DefaultSimpleTable_emptyState__2lwO9"};